<template>
  <tr
    class="table-tr-validation"
    :class="{ error: validationItter.error && validationItter.index == index }"
  >
    <td style="width: 5%">
      <button
        type="button"
        style="margin-top: 8px"
        :disabled="dataObjectRetribution.length <= 1"
        class="btn waves-effect waves-light mb-2"
        :class="classButton"
        @click="removeService"
      >
        <i class="fas fa-trash"></i>
      </button>
    </td>
    <td style="width: 25%">
      <div class="form-group mb-0">
        <select
          class="form-control select-2-custom-form"
          :disabled="loading"
          v-model="objectRetributionData.id"
          v-select2
        >
          <option value="" selected disabled>
            --- Pilih Kategori Retribusi ----
          </option>
          <option
            :value="item.id"
            :data-name="item.name"
            v-for="item in dataService"
            :key="item.id"
          >
            {{ item.name }}
          </option>
        </select>
      </div>
    </td>
    <td style="width: 25%">
      <div class="input-group mb-2">
        <input
          type="text"
          class="form-control"
          :readonly="!editablePrice"
          v-model="objectRetributionData.price"
          v-currency="currencyMask"
          :disabled="loading"
        />
        <div class="input-group-prepend" v-if="objectRetributionData.unit_type">
          <div class="input-group-text">
            / {{ objectRetributionData.unit
            }}{{ objectRetributionData.unit_type }}
          </div>
        </div>
      </div>
    </td>
    <td style="width: 15%">
      <div class="form-group mb-0">
        <input
          class="form-control number-form text-right"
          type="text"
          min="0"
          placeholder="eg. Masukkan Jumlah"
          v-currency="currencyMask"
          v-model="objectRetributionData.amount"
          :disabled="loading"
        />
      </div>
    </td>
    <td style="width: 25%">
      <div class="input-group">
        <input
          class="form-control text-right"
          type="text"
          v-currency="currencyMask"
          :value="objectRetributionData.total"
          readonly
        />

        <input
          class="form-control text-right"
          type="number"
          v-show="false"
          readonly
          v-model="objectRetributionData.total"
          :disabled="loading"
        />
      </div>
    </td>
  </tr>
</template>

<script>
export default {
  props: [
    "dataObjectRetribution",
    "dataService",
    "index",
    "loading",
    "validationItter",
  ],
  data() {
    return {
      // SET IF PRICE IS EDITABLE
      editablePrice: false,

      selectedPrice: 0,
      objectRetributionData: {
        index: this.index,
        id: null,
        price: 0,
        amount: 1,
        unit: 1,
        unit_type: null,
        total: 0

      },
    };
  },
  computed: {
    // SET BUTTON COLOR ON DELETE BUTTON
    classButton() {
      return this.dataObjectRetribution.length > 1 ? "btn-danger" : "btn-info";
    },
  },
  methods: {
    // REMOVE SERVICE $EMIT
    removeService() {
      this.$emit("handleRemove", {
        id: this.objectRetributionData.id,
        index: this.objectRetributionData.index,
      });
    },
    // SET VALUE $EMIT
    setValue() {
      this.$emit("handleData", {
        index: this.objectRetributionData.index,
        id: this.objectRetributionData.id,
        price: this.reInteger(this.objectRetributionData.price),
        unit: this.objectRetributionData.unit ?? 100,
        unit_type: this.objectRetributionData.unit_type,
        amount: this.reInteger(this.objectRetributionData.amount),
        total: this.reInteger(this.objectRetributionData.total),
      });
    },
  },
  watch: {
    // WATCH EVERY CHANGE ON ID
    "objectRetributionData.id": {
      async handler(val) {
        
        if(this.dataService != null || this.dataService == '' || this.dataService.length == 0){
            
          await this.$http.get(`${this.API_URL}service`, {
                headers: { 'Authorization': `Bearer ${this.$cookies.get("token_instance")}` }
            })
            .then(response => {
              this.dataService = response.data.data;
            });
        }

        
        const service = this.dataService;
        const self = this;
        
        //console.log(service);
        
        var getServiceDetail = service.find((item) => {
          return item.id == this.objectRetributionData.id;
        });

        let selectedEditable = false;
        if(getServiceDetail){
          this.selectedPrice = getServiceDetail.price
          this.editablePrice = getServiceDetail.is_editable_price
        }

        const objectRetribution = this.objectRetributionData

        if(objectRetribution.id && objectRetribution.amount > 0){
            objectRetribution.price = this.selectedPrice;

            if(getServiceDetail){
              this.objectRetributionData.unit = getServiceDetail.unit
              this.objectRetributionData.unit_type = getServiceDetail.unit_type
            }

            objectRetribution.total = function() {
              if(getServiceDetail != null) {
                    
                    const pricePerUnit = self.selectedPrice / getServiceDetail.unit
                    return objectRetribution.amount * pricePerUnit
                }else{
                    return objectRetribution.amount * self.selectedPrice
                }
            }()
        }

        this.setValue()
      },
    },
    // WATCH EVERY CHANGE ON PRICE
    "objectRetributionData.price": {
      handler(val) {
        const self = this;
        const objectRetributionData = this.objectRetributionData;
        objectRetributionData.total = (function () {
          if (objectRetributionData.unit) {
            const pricePerUnit =
              self.reInteger(objectRetributionData.price) /
              self.reInteger(objectRetributionData.unit);

              // console.log('price '+objectRetributionData.price);
              // console.log('unit '+objectRetributionData.unit);

              // console.log('amount '+objectRetributionData.amount);

              // console.log('priceuit '+pricePerUnit);

              // console.log(self.reInteger(objectRetributionData.amount) * self.reInteger(objectRetributionData.price));
              // console.log('if');

            return (
              self.reInteger(objectRetributionData.amount) *
              self.reInteger(pricePerUnit)
            );
          } else {
            // console.log(objectRetributionData.amount);
            // console.log(objectRetributionData.price);
            // console.log('else');
            return (
              self.reInteger(objectRetributionData.amount) *
              self.reInteger(objectRetributionData.price)
            );
          }
        })();
        this.setValue();
      },
    },
    // WATCH EVERY CHANGE ON AMOUNT
    "objectRetributionData.amount": {
      handler(val) {
        const self = this;
        const objectRetributionData = this.objectRetributionData;
        objectRetributionData.total = (function () {
          if (objectRetributionData.unit) {
            const pricePerUnit =
              self.reInteger(objectRetributionData.price) /
              self.reInteger(objectRetributionData.unit);
            return (
              self.reInteger(objectRetributionData.amount) *
              self.reInteger(pricePerUnit)
            );
          } else {
            return (
              self.reInteger(objectRetributionData.amount) *
              self.reInteger(objectRetributionData.price)
            );
          }
        })();
        this.setValue();
      },
    },
  },
  mounted() {
    const self = this;
    //console.log(this.dataObjectRetribution[this.index]);
    this.objectRetributionData = {
      index: this.index,
      id: this.dataObjectRetribution[this.index].id,
      price: this.dataObjectRetribution[this.index].price,
      amount: this.dataObjectRetribution[this.index].amount,
      unit: this.dataObjectRetribution[this.index].unit,
      unit_type: this.dataObjectRetribution[this.index].unit_type,
      total: this.dataObjectRetribution[this.index].total,
    };


    setTimeout(() => {
      $(".select-2-custom-form").select2();
    }, 10);

    // FORCE NUMBER FORM DEFAULT VALUE TO 1
    $(".number-form").blur(function () {
      if ($(this).val() == "" || $(this).val() < 1) {
        self.objectRetributionData.amount = 1;
      }
    });
  },
};
</script>

<style>
</style>